import React, {Component} from 'react';
import { Platform, View, Image, Text, FlatList, StyleSheet,
         ActivityIndicator, RefreshControl, TouchableHighlight } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import { Button, } from "native-base";
import { withTranslation } from "react-i18next";
import IsMobile from "../../utils/IsMobile";
import * as Helper from "../../utils/Helper";
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.screens.chinesepark.room;

class ConsumesView extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.setupList = this.setupList.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onEndReached = this.onEndReached.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.renderEmptyView = this.renderEmptyView.bind(this);
    }

    componentDidMount() {
        //this.onRefresh();
    }

    componentWillUnmount() {
    }

    setupList(r) {
        this._list = r;
    }

    onRefresh() {
        /*
        if (this.props.loading) {
            return;
        }
        if (this.props.onLoadPage) {
            this.props.onLoadPage(1);
        }
        */
    }

    onEndReached() {
        if (this.props.loading) {
            return;
        }
        if (this.props.allLoaded) {
            return;
        }
        if (this.props.onLoadPage) {
            this.props.onLoadPage(this.props.page + 1);
        }
    }

    renderItem({item, index}) {
        const itemStyle = IsMobile() ?
              {
                  marginLeft: (0 === index) ? 4 : 0, marginRight: 4,
                  flexDirection: 'row', alignItems: 'center'
              } : {
                  marginLeft: (0 === index) ? 0 : 4, marginRight: 0,
                  flexDirection: 'row', alignItems: 'center'
              };

        if (item.type === 1) {
            // 购买会员
            let month = this.props.t('1month');
            if (item.period === 3) {
                month = this.props.t('3month');
            }
            else if (item.period === 6) {
                month = this.props.t('halfYear');
            }
            else if (item.period === 12) {
                month = this.props.t('1year');
            }
            return (<View style={itemStyle}>
                        <View style={{flexDirection: 'row', alignItems: 'center',
                                      justifyContent: 'center', backgroundColor: '#00813f',
                                      height: (IsMobile() ? 36 : 32), borderRadius: 18,
                                      paddingLeft: 8, paddingRight: 8}}>
                            <Text ellipsizeMode="tail" numberOfLines={1}
                                  style={{maxWidth: 50, color: '#fff'}}>
                                {item.name}
                            </Text>
                            <View style={{marginLeft: 2, flexDirection: 'column'}}>
                                <Text style={{fontSize: 9, color: '#fff'}}>{month}</Text>
                                <Text style={{fontSize: 9, color: '#fff'}}>{this.props.t('roomVip')}</Text>
                            </View>
                        </View>
                    </View>);
        }

        // 打赏
        const { usdCurrency, cnyCurrency } = this.props.currencyInfo;
        const { amount, currencyCode, colorIndex } = item;

        const currency = currencyCode === 'CNY' ? cnyCurrency : usdCurrency;
        const targetRate = (currency && currency.targetRate > 0) ? currency.targetRate : 1.0;
        const currencySymbol = currencyCode === 'CNY' ? '¥' : '$'
        let usdAmount = Math.round(amount / targetRate);
        let currentMoneyColor = '#6300c2';
        if (2 === colorIndex) {
            currentMoneyColor = '#ff3f22';
        }
        else if (1 === colorIndex) {
            currentMoneyColor = '#00c1a3';
        }

        return (<View style={itemStyle}>
                    <View style={{flexDirection: 'row', alignItems: 'center',
                                  justifyContent: 'center', backgroundColor: currentMoneyColor,
                                  height: (IsMobile() ? 36 : 32), borderRadius: 18,
                                  paddingLeft: 8, paddingRight: 8}}>
                        <Text ellipsizeMode="tail" numberOfLines={1}
                              style={{maxWidth: 50, color: '#fff'}}>
                            {item.name}
                        </Text>
                        <Text style={{marginLeft: 2, color: '#fff'}}>
                            {currencySymbol + Math.round(amount)}
                        </Text>
                    </View>
                </View>);
    }

    renderFooter() {
        return null;
    }

    renderEmptyView() {
        return null;
    }

    render() {
        return (<View style={IsMobile() ? styles.container : styles.containerPC}>
                    <FlatList ref={this.setupList}
                              data={this.props.data}
                              keyExtractor={(item, index) => '' + index}
                              renderItem={this.renderItem}
                              ListEmptyComponent={this.renderEmptyView}
                              ListFooterComponent={this.renderFooter}
                              onEndReached={this.onEndReached}
                              onEndReachedThreshold={0.2}
                              horizontal={true}
                              numColumns={1}
                              refreshControl={this.props.onLoadPage ?
                                              (<RefreshControl
                                                   refreshing={this.props.loading && (1 === this.props.page)}
                                                   onRefresh={this.onRefresh}
                                                   colors={['#ff0000', '#00ff00','#0000ff','#3ad564']}
                                                   progressBackgroundColor="#ffffff"
                                               />) : null}
                    />
                </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        height: 46,
        backgroundColor: '#282828',
    },
    containerPC: {
        backgroundColor: '#252631',
    },
});

export default withTranslation(uid, { withRef: true })(ConsumesView);
